module.exports = __webpack_public_path__ + "img/bg_main.6bf841ed.png";